import { capitalizeFirst } from '@shared/utils/capitalize';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { RiAddCircleLine } from 'react-icons/ri';

export function CreateWorkspace({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation();

  const content = (
    <div className="flex gap-1.5 pt-2 ml-3">
      <RiAddCircleLine className="text-primary self-center" size={20} />
      <p className="font-normal text-sm text-text-600">{capitalizeFirst(t('create_new_workspace'))}</p>
    </div>
  );

  return (
    <div
      className="flex flex-col items-start cursor-pointer pb-3 bg-surface border-t border-gray-400"
      onClick={onClick}
    >
      {onClick ? (
        content
      ) : (
        <Tooltip title={t('this_feature_is_not_available_yet')} placement="bottom">
          {content}
        </Tooltip>
      )}
    </div>
  );
}
